interface ErrorDisplayProps {
  message: string;
  description?: string;
  onRetry?: () => void;
}

export default function ErrorDisplay({ message, description, onRetry }: ErrorDisplayProps) {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 text-center text-[#333333] bg-white"
      style={{
        backgroundImage: "url('/images/bg.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="max-w-sm rounded-3xl bg-white px-6 py-8">
        <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-[#E63232]/15">
          <span className="text-3xl" role="img" aria-label="提示">
            ⚠️
          </span>
        </div>
        <h2 className="mb-2 text-xl font-semibold text-[#E63232]">{message}</h2>
        <p className="text-sm text-gray-600">
          {description || 'Please confirm that the NFC ID is correct, or try again later.'}
        </p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-6 inline-flex items-center justify-center rounded-full bg-[#1B1B1B]/90 px-6 py-2 text-sm font-semibold text-white transition hover:bg-[#1B1B1B]"
          >
            Reload
          </button>
        )}
      </div>
    </div>
  );
}
